import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, updateDoc, arrayRemove } from "firebase/firestore";
import { db } from "../firebase";
import SevakForm from "./ttdSeva"; 
import MemberDetailsModal from "./MemberDetailModel";
import generateGroupPDF from "./GroupMembersPDF";
import { Button } from "react-bootstrap";

const GroupDetailsPage = () => {
  const { groupId } = useParams();
  const [group, setGroup] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [editMode, setEditMode] = useState(false);
const [sevakToEdit, setSevakToEdit] = useState(null);


  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const docRef = doc(db, "sevakGroups", groupId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setGroup(docSnap.data());
        } else {
          console.error("Group not found");
        }
      } catch (err) {
        console.error("Error loading group:", err);
      }
    };
    fetchGroup();
  }, [groupId]);

  const handleMemberClick = (member) => {
    setSelectedMember(member);
    setShowModal(true);
  };

  const handleDeleteSevak = async (sevak) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${sevak.sevakName}?`
    );
    if (!confirmDelete) return;

    try {
      const groupRef = doc(db, "sevakGroups", groupId);
      await updateDoc(groupRef, {
        members: arrayRemove(sevak),
      });
      setGroup((prev) => ({
        ...prev,
        members: prev.members.filter(
          (member) => member.AdharNumber !== sevak.AdharNumber
        ),
      }));
    } catch (err) {
      console.error("Error deleting sevak:", err);
    }
  };

  if (!group) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="ms-3">Group Details</h5>
          <Button
            variant="outline-primary"
            className="me-3 mb-2"
            onClick={() => generateGroupPDF(group)}
          >
            Download PDF
          </Button>
        </div>

        <div
          className=""
          style={{
            border: "1px solid #1E0F2E",
            borderRadius: "5rem",
            backgroundColor: "#fff",

          }}
        >
          <div className="ms-3 d-flex flex-row gap-5 mt-2">
            <p className="ms-4">
              <strong>
                Group ID:{" "}
                <span className="ms-3">
                  {" "}
                  <p className="text-primary">{group.accountId || group.groupId}</p>
                </span>
              </strong>
            </p>
            <p className="ms-5">
              <strong>
                Group Name:{" "}
                <span className="ms-3"> <p className="text-primary">{group.groupName || group.name}</p></span>
              </strong>
            </p>
            <p className="ms-5">
              <strong>
                Station:<span className="ms-3"> <p className="text-primary">{group.location}</p></span>
              </strong>
            </p>
            <p className="ms-5">
              <strong>
                Images Path:
                <span className="ms-3"><p className="text-primary"> {group.imageFolderPath}</p></span>
              </strong>
            </p>
            <p className="ms-5">
              <strong>
                Total Members:
                <span className="ms-3"> <p className="text-primary">{group.members?.length || 0} / 15 </p></span>
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div>
        {" "}
        <h5 className="mt-4 ms-3" style={{ color: "#1E0F2E" }}>
          Team Leader:
        </h5>
      </div>
      <div
        className="card mb-4 border border-dark round roudned-5"
        style={{
          border: "1px solid #ccc",
          borderRadius: "5rem",
        }}
      >

        <div className="card-body">
          {group.members
            .filter((m) => m.designation === "teamleader")
            .map((leader, idx) => (
              <div key={idx}>
                <div className="d-flex flex-row align-items-center gap-5 w-100 ">
                  <p className="card-title ms-4">1</p>
                  <p className="card-title">
                    Name:{" "}
                    <span className="fw-bold ms-2">{leader.sevakName}</span>
                  </p>
                  <p className="card-text mb-1">
                    Account ID:{" "}
                    <span className="fw-bold ms-2">{leader.accountId}</span>
                  </p>
                  <p className="card-text mb-1">
                    DOB: <span className="fw-bold ms-2"> {leader.dob}</span>
                  </p>
                  <p className="card-text mb-1">
                    Age: <span className="fw-bold ms-2"> {leader.age}</span>
                  </p>
                  <p className="card-text mb-1">
                    Mobile:{" "}
                    <span className="fw-bold ms-2"> {leader.mobileNo}</span>
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle text-center">
          <thead className="table-light">
            <tr>
              <th scope="col">S.No</th>
              <th scope="col">Account ID</th>
              <th scope="col">Name</th>
              <th scope="col">DOB</th>
              <th scope="col">Age</th>
              <th scope="col">Mobile</th>
              <th scope="col">Aadhar</th>
              <th scope="col">Edit</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {group.members
              .filter((m) => m.designation === "member")
              .map((member, idx) => (
                <tr
                  key={idx}
                  onClick={() => handleMemberClick(member)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{idx + 1}</td>
                  <td>{member.accountId}</td>
                  <td>{member.sevakName}</td>
                  <td>{member.dob}</td>
                  <td>{member.age}</td>
                  <td>{member.mobileNo}</td>
                  <td>{member.AdharNumber}</td>
                  {/* <td>
                    <button
                      className="btn btn-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteSevak(member);
                      }}
                    >
                      X
                    </button>
                  </td> */}

                  <td>
  <button
    className="btn btn-sm btn-success me-2"
    onClick={(e) => {
      e.stopPropagation();
      setEditMode(true);
      setSevakToEdit(member);
    }}
  >
    Edit
  </button>
  </td>
  <td>
  <button
    className="btn btn-sm btn-danger"
    onClick={(e) => {
      e.stopPropagation();
      handleDeleteSevak(member);
    }}
  >
    X
  </button>
</td>

                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <MemberDetailsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        member={selectedMember}
      />
      {group.members?.length < 15 ? (
        <div className="mt-4 border border-dark rounded rounded-3 p-3">
          <h4>Add Sevak</h4>
          {/* <SevakForm
            groupId={groupId}
            groupData={group}
            onSevakAdded={(newSevak) => {
              setGroup((prev) => ({
                ...prev,
                members: [...(prev.members || []), newSevak],
              }));
            }}
          /> */}
          <SevakForm
  groupId={groupId}
  groupData={group}
  editMode={editMode}
  sevakToEdit={sevakToEdit}
  onSevakAdded={(newSevak) => {
    if (editMode) {
      setGroup((prev) => ({
        ...prev,
        members: prev.members.map((m) =>
          m.AdharNumber === newSevak.AdharNumber ? newSevak : m
        ),
      }));
      setEditMode(false);
      setSevakToEdit(null);
    } else {
      setGroup((prev) => ({
        ...prev,
        members: [...(prev.members || []), newSevak],
      }));
    }
  }}
/>

        </div>
      ) : (
        <div className="alert alert-info">
          Quota filled. Cannot add more sevaks.
        </div>
      )}
    </div>
  );
};

export default GroupDetailsPage;
